<template>
  <div class="checklistItem">
    <slot />
  </div>
</template>

<script>
export default {
  props: {},
};
</script>

<style scoped>
.checklistItem {
  display: flex;
  gap: 4px;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px;
  width: 100%;

  background-color: var(--gray-0);
  border-radius: 6px;
  box-shadow: 0px 1px 1px 0px rgba(114, 113, 125, 0.25);
  color: var(--blue-500);
  transition: all 80ms ease-in-out;

  cursor: pointer;
}

.checklistItem:hover {
  background-color: var(--blue-25);
}

.checklistItem small {
  overflow: hidden;
  width: calc(100% - 32px);

  text-align: left !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
